import {
  CREATE_PAIN_FAILURE,
  CREATE_PAIN_SUCCESS,
  GET_PAIN_HISTORY,
  GET_PAIN_HISTORY_FAILURE,
  GET_PAIN_HISTORY_REQUEST,
  GET_STOCK,
  GET_STOCK_FAILURE,
  GET_STOCK_REQUEST,
} from "../types/pain";

export const getPainStock = (token) => {
  return (dispatch) => {
    dispatch({ type: GET_STOCK_REQUEST });
    fetch("https://shopngo.herokuapp.com/api/bread-stock/list", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.errors) {
          dispatch({
            type: GET_STOCK_FAILURE,
            value: res.errors.status,
          });
        } else {
          dispatch({ type: GET_STOCK, value: res });
        }
      })
      .catch((error) => console.log(error));
  };
};

export const createNewPain = (token, type, price) => {
  return (dispatch) => {
    fetch("https://shopngo.herokuapp.com/api/bread-stock/", {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
      body: JSON.stringify({
        type: type,
        price: price,
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.errors) {
          dispatch({
            type: CREATE_PAIN_FAILURE,
            value: res.errors.status,
          });
        } else {
          dispatch({ type: CREATE_PAIN_SUCCESS, value: res });
        }
      })
      .catch((error) => console.log(error));
  };
};

export const getPainHistory = ({ token, pageNumber }) => {
  return (dispatch) => {
    dispatch({ type: GET_PAIN_HISTORY_REQUEST });
    fetch(
      `https://shopngo.herokuapp.com/api/bread-stock/history?pageNumber=${pageNumber}`,
      {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
      }
    )
      .then((response) => response.json())
      .then((res) => {
        console.log(res);
        if (res.errors) {
          dispatch({
            type: GET_PAIN_HISTORY_FAILURE,
            value: res.errors.status,
          });
        } else {
          dispatch({ type: GET_PAIN_HISTORY, value: res });
        }
      })
      .catch((error) => console.log(error));
  };
};
